import React, { useState } from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.less';
import { handleInstaLink } from '@/utils';

const getPersonalMenusList = ({ area, auth, app, gold }) => {
  const { LANG } = area;
  const { isMobile } = app;
  const menus = [];
  const MenuPersonal = [
    {
      name: '移动端积分',
      title: LANG['common.label.gold'],
      type: 'button',
      icon: 'https://res.insta360.com/static/8dc5705e9ae5626b71d96faca71dc9cd/gold-icon.png',
      onClick: () => {},
    },
    {
      name: '登录',
      title: LANG['common.btn.login'],
      url: handleInstaLink('www', `/account/login?redirect_url=${window.location.href}`, app),
      type: 'hyperlink',
      icon: 'https://res.insta360.com/static/6a3f0585b19c8bd8863bba231cb98e22/account.svg',
    },
    {
      name: '注册',
      title: LANG['common.btn.register'],
      url: handleInstaLink('www', `/account/register?redirect_url=${window.location.href}`, app),
      type: 'hyperlink',
      icon: 'https://res.insta360.com/static/6a3f0585b19c8bd8863bba231cb98e22/account.svg',
    },
    {
      name: '我的账户',
      title: LANG['common.btn.myAccount'],
      url: handleInstaLink('www', '/account/profile', app),
      type: 'hyperlink',
      icon: 'https://res.insta360.com/static/6a3f0585b19c8bd8863bba231cb98e22/account.svg',
    },

    {
      name: '我的兑换',
      title: LANG['common.btn.myRedemption'],
      url: handleInstaLink('www', '/account/exchange', app),
      type: 'hyperlink',
      icon: 'https://res.insta360.com/static/8e81af07019fd8e1ec9089b72f75d4f7/exchange.svg',
    },
    {
      name: '我的优惠',
      title: LANG['common.btn.myCoupons'],
      url: handleInstaLink('www', '/account/coupon', app),
      type: 'hyperlink',
      icon: 'https://res.insta360.com/static/8179c35d4c9a47eaf29c32832ba3b8a7/coupon.svg',
    },
    {
      name: '我的积分',
      title: LANG['common.btn.myInsta360Gold'],
      url: handleInstaLink('www', '/account/gold', app),
      type: 'hyperlink',
      icon: 'https://res.insta360.com/static/291365dcb97b95d37ce79ccef64e7f5e/gold.svg',
    },
    {
      name: '退出登录',
      title: LANG['common.btn.logout'],
      type: 'button',
      icon: 'https://res.insta360.com/static/736137be2572ff3cb7baa55dcfd7b987/logoout.svg',
      onClick: () => {},
    },
  ];
  MenuPersonal.forEach((o) => {
    switch (o.name) {
      case '移动端积分':
        if (auth.alreadyAuth && !isNaN(gold.userPoint) && isMobile) {
          o.title = `${gold.userPoint} ${o.title}`;
          menus.push(o);
        }
        break;
      case '登录':
      case '注册':
        if (!auth.alreadyAuth) menus.push(o);
        break;
      case '我的账户':
      case '我的兑换':
      case '我的优惠':
      case '我的积分':
      case '退出登录':
        if (o.name === '退出登录') o.onClick = auth.logout;
        if (auth.alreadyAuth) menus.push(o);
        break;
      default:
        break;
    }
  });
  return menus;
};

const Personal = inject(
  'area',
  'auth',
  'app',
  'gold'
)(
  observer((props) => {
    const { auth, area, app, gold } = props;
    const { isMobile } = app;
    const [visible, setVisible] = useState(false);

    const toggleVisible = (visible) => {
      setVisible(visible);
    };

    const onClick = (item) => {
      if (['hyperlink', 'link'].includes(item.type)) {
        window.location.href = item.url;
      } else if (item.type === 'button') {
        item?.onClick();
      }
    };

    const PersonalMenus = getPersonalMenusList({ area, auth, app, gold });

    return (
      <div
        className={styles.Personal}
        onMouseEnter={() => (!isMobile ? toggleVisible(true) : null)}
        onMouseLeave={() => toggleVisible(false)}
      >
        <button className={`${styles.btn} ${isMobile ? styles.mobile : ''}`} onClick={() => toggleVisible(!visible)}>
          <img src='https://res.insta360.com/static/a3edfee74711dfd29d203e00cb996371/Frame%201273.svg' alt='' />
        </button>
        {visible ? (
          <div className={styles.popup}>
            <div className={styles.wrap}>
              <ul className={styles.container}>
                {PersonalMenus.map((o, k) => (
                  <li key={k}>
                    <button onClick={() => onClick(o)}>
                      <img className={styles.ic} src={o.icon} alt='' />
                      {o.title}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ) : null}
      </div>
    );
  })
);

export default Personal;
